import { isUndefined } from "lodash";
import React from "react";

import { FinderBlockProps } from "@/components/V2/Block";

export const useEligibility = (
  eligibilityRules: FinderBlockProps["search"]["eligibility"] | undefined,
  age?: number
) => {
  // eligibilityRules has keys of the form min-max age. We need to find the eligibility rule that matches the age
  const eligibility = React.useMemo(() => {
    if (!eligibilityRules || age === undefined) {
      return null;
    }

    const foundEntry = Object.entries(eligibilityRules).find(([key]) => {
      const [min, max] = key.split("-").map(Number);

      if (isUndefined(min) || isNaN(min) || isUndefined(max) || isNaN(max)) {
        return false;
      }

      return age >= min && age <= max;
    });

    return foundEntry ? foundEntry[1] : null;
  }, [eligibilityRules, age]);

  return eligibility;
};
